import React from 'react'
import { IoPersonOutline } from 'react-icons/io5'
import { formatTime, setAgencyInfluencerProfile } from '../../utils'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AGENCY_INFLUENCER_STORAGE_KEY, ROLE_AGENCY, ROLE_INFLUENCER } from '../../constants'
import { set_chat_to_load } from '../../redux/slices/chatsSlice'
import { set_global_notifications } from '../../redux/slices/globalNotificationsSlice'
import { set_active_profile } from '../../redux/slices/influencerProfileSlice'
import useApi from '../../hooks/useApi'
import { FormattedMessage } from 'react-intl'

const NotificationItem = ({ payload, handleUnread, type, setLoading }) => {
    const agency_as_influencer = useSelector(state => state.influencer_profile.active);
    const user = useSelector(state => state.user);
    const global_notifications = useSelector(state => state.global_notifications);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Axios } = useApi()


    const handleNavigate = async () => {
        console.log("payload", payload);
        setLoading(true);
        
        try {
            // Common notification update logic
            const updateNotifications = () => {
                dispatch(set_global_notifications({
                    sidebar: false,
                    sidebar_api_data: global_notifications.sidebar_api_data.map(item =>
                        item.id === payload?.id ? { ...item, is_read: true } : item
                    ),
                    ...(payload?.is_read === false && {
                        unread_count: global_notifications.unread_count - 1
                    })
                }));
            };
    
            if (!payload?.influencer_id) {
                // Case 1: No influencer_id
                dispatch(set_active_profile(null));
                localStorage.removeItem(AGENCY_INFLUENCER_STORAGE_KEY);
                navigate(`/campaign/${payload?.campaign_id}/chats`);
                let timer = setTimeout(() => {
                    dispatch(set_chat_to_load(payload?.session_id));
                }, 300)

                updateNotifications();
                return;
            }
    
            // Case 2: With influencer_id
            if (user.role === ROLE_INFLUENCER.value || 
                (agency_as_influencer && agency_as_influencer.id === payload?.influencer_id)) {
                // Influencer or agency acting as influencer
                updateNotifications();
                navigate(`/chats/${payload?.session_id}`);
                return;
            }
    
            // Agency case - need to fetch influencer profile
            const result = await Axios.get(`api/influencer/${payload?.influencer_id}`);
            dispatch(set_active_profile(result.data.payload));
            setAgencyInfluencerProfile(result.data.payload);
            updateNotifications();
            let timer = setTimeout(() => {
               navigate(`/chats/${payload?.session_id}`);
           }, 500);
    
        } catch (error) {
            console.error("Navigation error:", error);
            // Consider adding error handling/feedback to user here
        } finally {
            setLoading(false);
        }
    };

    return (
        <div  className='px-6 cursor-pointer hover:bg-primary/20 border-b-2 py-2' onClick={handleNavigate} >
            <div
            className='flex items-center'>
            <div className="relative mr-3 flex-shrink-0">
                {payload?.sender_picture ? (
                    <img
                        src={payload?.sender_picture}
                        alt={`${payload?.sender_name} ${payload.sender_sur_name}`}
                        className="w-12 h-12 min-w-12 min-h-12 rounded-full object-cover shadow" />
                ) : (
                    <div className="w-12 h-12 min-w-12 min-h-12   rounded-full bg-gray-200 flex items-center justify-center shadow">
                        <IoPersonOutline className='text-2xl text-gray-500' />
                    </div>
                )}
                {!payload?.is_read && (
                    <div className="absolute -top-1 -right-1 bg-primary text-white rounded-full w-3 h-3 flex items-center justify-center text-[9px] ">                                    </div>
                )}
            </div>

            <div className="flex-1 min-w-0">
                <div className="flex justify-between items-center ">
                    {user?.role === ROLE_AGENCY.value && payload?.influencer_id ?
                        <h3 className="font-semibold break-words  text-gray-900 text-[13px]">
                            <FormattedMessage id="got_a_message_for_influencer" defaultMessage={"Got a message for influencer:"} /> {payload.influencer_first_name} {payload.influencer_last_name}
                        </h3>
                        :
                        <h3 className="font-semibold break-all !line-clamp-2 text-gray-900 text-[13px]">
                            {payload.sender_name} {payload.sender_sur_name}
                        </h3>}

                </div>

                <div
                    //  onClick={(e) => {
                    //     e.stopPropagation();
                    //     if (!agency_as_influencer || user.role !== ROLE_INFLUENCER.value) {
                    //         navigate(`/campaign/${payload?.campaign_id}`);
                    //         dispatch(set_global_notifications({ sidebar: false }))
                    //     }
                    // }}
                    className={`flex justify-start items-center `}>
                    <p className={`text-xs text-gray-500`}>
                        {payload?.campaign_name || ''}
                    </p>
                </div>
                <div className='flex justify-start items-center mt-1'>
                    <p className="text-xs !line-clamp-1 text-gray-500">
                        {payload?.message || ''}
                    </p>
                </div>
            </div>
        </div><div className='flex justify-end w-full'>
                {payload?.timestamp &&
                    <span className="text-[11px] text-gray-500 flex-shrink-0 ml-2">
                        {formatTime(payload?.timestamp)}
                    </span>}
                {payload?.created_on &&
                    <span className="text-[11px] text-gray-500 flex-shrink-0 ml-2">
                        {formatTime(payload?.created_on)}
                    </span>}
            </div></div>
    )
}

export default NotificationItem